import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import {React, useMemo} from 'react';
import './Home.css';

const Map = () => {
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    });
    const center = useMemo(() => ({ lat: 30.63846, lng: -97.81224}), [])

    return (
        <div className="map">
            {!isLoaded ? (
                <p>Loading...</p>
            ) : (
                <GoogleMap
                mapContainerClassName='map-container'
                center={center}
                zoom={10}>
                <Marker position={{ lat: 30.63846, lng: -97.81224 }}/>
                </GoogleMap>
            )}
        </div>
    );
};

export default Map